module.exports = {
  EVENT_SCHEDULE_RECURRING_TYPE: {
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
    YEARLY: 'Yearly',
    HOURLY: 'Hourly'
  },
  EVENT_TYPE: {
    PAYMENT: 'PAYMENT'
  }
};
